import React from 'react'

const NotFound = () => {
  return(
      <div className="not-found">
        <h1>HTTP ERROR 404: NOT FOUND</h1>
      </div>
    )
}

export default NotFound;